'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (i) {
  switch (i) {
    case 1:
      return '0.3s';

    case 3:
      return '0.6s';

    case 2:
      return '0.9s';

    default:
      return false;
  }
};